module.exports = __webpack_public_path__ + "assets/3bd6b7e8bb7596d4d52320b2c879f7bc.woff";